export class ThinningAndHarvestAge {
  siteCurveId: number;
  siteQuality: number;
  thinAge: number;
  harvestAge: number;
}
